// src/auth/AuthProvider.js
import React from 'react';

import { EntraAuthProvider } from './EntraAuthProvider';

export { useAuth } from './AuthContext';

export function AuthProvider({ children }) {
  
     return <EntraAuthProvider>{children}</EntraAuthProvider>

}
